export default "__VITE_ASSET__C8ekdiio__"